import { render, staticRenderFns } from "./HelpGuide.vue?vue&type=template&id=506c5d66&scoped=true"
import script from "./HelpGuide.vue?vue&type=script&lang=js"
export * from "./HelpGuide.vue?vue&type=script&lang=js"
import style0 from "./HelpGuide.vue?vue&type=style&index=0&id=506c5d66&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "506c5d66",
  null
  
)

export default component.exports